import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import InheritedCompanies from '@app/pages/inherited-companies/InheritedCompanies.tsx';
import Intro from '@app/layout/Intro.tsx';
import React from 'react';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const InheritedCompaniesPage = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout title={tr(`inherited-companies.inheritedCompanies`, `Inherited companies`)} oneOfPermission={[PermissionTypesEnum.PERMISSION_SETTINGS_INHERITED_COMPANIES_READ]}>
      <InheritedCompanies />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(InheritedCompaniesPage, {
  onRedirecting: () => <Intro />,
});
